
import {
	Math as THREEMath,
	Vector3,
	Color,
	TextureLoader,
	Mesh,
	MeshLambertMaterial,
	MeshBasicMaterial,
	MeshStandardMaterial,
	CubeGeometry,
	PointLightHelper,
	HemisphereLightHelper,
	SpotLightHelper,
	DirectionalLightHelper,
	AxesHelper,
	//ObjectLoader,
	Matrix3,
	Object3D,
	Box3,
	BoxHelper,
	VideoTexture,
	MeshPhongMaterial
} from '../../../../src/js/three.module.js';

import { ObjectLoader } from '../../../utils/object-loader.js';

import {
	rotateAroundWorldAxis,
	roundVector
} from '../../GameTools.js';

import { ObjectClickHandler }       from '../../../utils/object-click-handler.js';

import { CommentsHandler }      from '../../services/CommentsService.js';
import UserActionHistoryService from '../../services/UserActionHistoryService.js';
import { buildMaterialParameters, createDefaultMaterial, createMaterialByImageUrl, createTextureByImageUrl } from './utils.js';

import { GameSceneService } from '../../services/game-scene.service.js';

import { createHemisphereGroundColor } from '../../../utils/colors.js';

import { getAdditionalObjectsService } from "./utils.js";

import { BaseAdditionalObject } from './base-additional-object.js';

export class AdditionalObjectLight extends BaseAdditionalObject {

    constructor( obj, opts ) {

        super( obj );

        this.type = "light";

        this.opts = angular.extend({

            color: (obj.color ? "#" + (new Color( obj.color )).getHexString() : undefined),

            intensity: typeof obj.intensity == "number" ? obj.intensity : 1

            // @TODO: Lisää kaikki muutkin parametrit 20.5.2021 -m
            
        }, opts || {});

        obj.$parent = this;

        obj.castShadow = true;

        try {
            obj.castShadow = angular.element( document.body ).injector().get( "LODService" ).levelOfDetailProperties.lightsCastShadow.enabled;
        } catch (error) {
            console.warn( error );
        }

        if (this.availPlanes.ceiling == null) {
            // Tehdään oletus, että jollei muuta ole asetettu, voidaan valo sijoittaa myös kattoon
            this.availPlanes.ceiling = true;
        }

        if (obj.isPointLight) {

            this.wireframe = new PointLightHelper( obj, 0.1 );			
            obj.distance = 10;

        } else if (obj.isSpotLight) {
            this.wireframe = new SpotLightHelper( obj );

            /**
             * Lisätään SpotLight'n kohde sceneen ja saadaan näin SpotLight'n "suunta" ohjailtavaksi pyörittelemällä sitä
             */
            obj.add( obj.target );
            
            obj.distance = 10;
            obj.target.position.set( 0, -1, 0 );

        } else if (obj.isHemisphereLight) {
            this.wireframe = new HemisphereLightHelper( obj, 0.1 );
            Object.defineProperty( obj, 'castShadow', {
                get: () => false,
                set: angular.noop
            });
        } else if (obj.isDirectionalLight) {
            this.wireframe = new DirectionalLightHelper( obj, 0.1 );
        } else {
            this.wireframe = new AxesHelper( 1 );
            Object.defineProperty( obj, 'castShadow', {
                get: () => false,
                set: angular.noop
            });
        }

        this.setWireframe();
        
        let additionalObjectsService = this.service;
        additionalObjectsService.add( this.wireframe );

        var properties = {
            color: {
                get: angular.noop, set: angular.noop
            },
            intensity: {
                get: angular.noop, set: angular.noop
            },
            distance: {
                get: angular.noop, set: angular.noop
            },
            angle: {
                get: angular.noop, set: angular.noop
            },
            decay: {
                get: angular.noop, set: angular.noop
            },
            penumbra: {
                get: angular.noop, set: angular.noop
            }
        };

        switch (this.mesh.type) {
            case "SpotLight":

                /**
                 * Maximum angle of light dispersion from its direction whose upper bound is Math.PI/2.
                 */
                properties.angle = {
                    set: function(v){
                        this.opts.angle = Math.max( 0, Math.min( Math.PI/2, parseFloat( v )));
                        this.optsChanged();
                    },
                    get: function( ){ return this.mesh.angle; }
                };

                /**
                 * Percent of the spotlight cone that is attenuated due to penumbra. Takes values between zero and 1. Default is zero.
                 */
                properties.penumbra = {
                    set: function(v){ this.opts.penumbra = this.mesh.penumbra = Math.max( 0, Math.min( 1, parseFloat( v ))); },
                    get: function( ){ return this.mesh.penumbra; }
                };

                // jshint ignore:start
            case "PointLight":
                // jshint ignore:end

                /**
                 * Maximum range of the light. Default is 0 (no limit).
                 */
                properties.distance = {
                    set: function( distance ) {
                        this.opts.distance = Math.max( 0, parseFloat( distance ));
                        this.optsChanged();
                        //this.opts.distance = this.mesh.distance = Math.max( 0, parseFloat( v ));

                    },
                    get: function( ){ return this.mesh.distance; }
                };

                /**
                 * The amount the light dims along the distance of the light.
                 */
                properties.decay = {
                    set: function(v){ this.opts.decay = this.mesh.decay = parseFloat(v); },
                    get: function( ){ return this.mesh.decay; }
                };

            default:
                // if (RectAreaLight) kuuluisi tähän omine ominaisuuksineen width & height
        }


        { // properties.color

            /**
            * Hexadecimal color of the light. Default is 0xffffff (white)
            */
            if (this.mesh.type == "HemisphereLight") {

                properties.color = {
                    set: function( v ){
                        this.opts.color = this.mesh.color ? "#" + this.mesh.color.getHexString() : undefined;
                        this.optsChanged();
                    },
                    get: function( ){ return "#" + this.mesh.color.getHexString(); }
                }

            } else {

                properties.color = {
                    set: function( v ){
                        this.mesh.color.set( v );
                        this.opts.color = this.mesh.color ? "#" + this.mesh.color.getHexString() : undefined;
                        this.optsChanged();
                    },
                    get: function( ){ return "#" + this.mesh.color.getHexString(); }
                };
            }
        }

        { // properties.intensity
            
            /**
             * Numeric value of the light's strength/intensity. Default is 1.
             */
            properties.intensity = {
                set: function(v){ this.opts.intensity = this.mesh.intensity = parseFloat(v); },
                get: function( ){ return this.mesh.intensity; }
            };
        }



        Object.defineProperties( this, properties );

        this.optsChanged();
        this.onSelectChange();
    }

    setPlaceByIntersect( intersect ) {

        var point = AdditionalObjectJSON.prototype.setPlaceByIntersect.call( this, intersect );

        if (!point) return;

        GameSceneService.getInstance().shadowsNeedsUpdate = true;

        // Siirretään valoa 10cm ulos seinästä siten että se erottuu kaikissa tilanteissa
        if (this.$lastNormal) {
            this.mesh.position.addScaledVector( this.$lastNormal, 0.1 );
        }
    }

    /**
     * Toteutetaan .opts'n säilömät arvot objektissa
     */
    optsChanged() {

        // SpotLight
        if (this.opts.angle     != null) this.mesh.angle    = this.opts.angle;
        if (this.opts.penumbra  != null) this.mesh.penumbra = this.opts.penumbra;

        // PointLight
        if (this.opts.distance  != null) this.mesh.distance = this.opts.distance;
        if (this.opts.decay     != null) this.mesh.decay    = this.opts.decay;

        // Light
        if (this.opts.intensity != null) this.mesh.intensity = this.opts.intensity;
        if (this.opts.color     != null) {

            this.mesh.color.set( this.opts.color );

            if (this.mesh.isHemisphereLight) {
                this.mesh.groundColor.set( createHemisphereGroundColor( this.opts.color ));
            }
        }

        if (typeof this.wireframe?.update == "function") this.wireframe.update();

        
        this.refreshHash();
    }

    refreshHash() {
        var old_hash = this.obj_hash;
//		if( typeof self.objects_by_hash[ this.obj_hash ] == "object" ){
//			delete self.objects_by_hash[ this.obj_hash ][ this.uuid ];
//			if( Object.keys(self.objects_by_hash[ this.obj_hash ]).length == 0 ) delete self.objects_by_hash[ this.obj_hash ];
//		}

        this.obj_hash = this.type+"-"+this.mesh.uuid;

//		self.objects_by_hash[ this.obj_hash ] = self.objects_by_hash[ this.obj_hash ] || {};
//		self.objects_by_hash[ this.obj_hash ][ this.uuid ] = this;

        if (old_hash != this.obj_hash) {
            let additionalObjectsService = this.service;
            additionalObjectsService.objectHashUpdateNeeded = true;
            // console.log("AdditionalObject.Light.refreshHash() :: Hash changed!", old_hash, this.obj_hash, this);
        }
    }

    onSelectChange() {
        if (this.wireframe) this.wireframe.visible = (GameSceneService.getInstance().editor && this.selected) ? true : false;
    }

    toJSON() {
        var save = {
            title     : this.title,
            intensity : this.mesh.intensity,
            stype     : this.mesh.type,
            color     : this.mesh.color ? "#" + this.mesh.color.getHexString() : undefined,
            opts      : this.opts,
            pos       : this.mesh.position.toArray(),
            qua       : this.mesh.quaternion.toArray(),
            disabled  : !!this.disabled
        };

        if (this.mesh.distance != null) save.distance = this.mesh.distance;
        if (this.mesh.decay    != null) save.decay    = this.mesh.decay;
        if (this.mesh.penumbra != null) save.penumbra = this.mesh.penumbra;
        if (this.mesh.angle    != null) save.angle    = this.mesh.angle;

        return save;
    }

    /**
     * Luodaan objekti tallennetu datapaketin pohjalta
     */
    static loadSave( save ) {
        let additionalObjectsService = getAdditionalObjectsService();
        var obj = additionalObjectsService.objects[ save.uuid ];

        if (!obj) {

            obj = UserActionHistoryService.getInstance().acts["additionalObject.light.create"].redo( save );
        }

        if (!obj) return;

        if (save.title    != null) obj.title         = save.title;

        if (save.distance != null) obj.mesh.distance = save.distance;
        if (save.decay    != null) obj.mesh.decay    = save.decay;
        if (save.penumbra != null) obj.mesh.penumbra = save.penumbra;
        if (save.angle    != null) obj.mesh.angle    = save.angle;
        

        obj.intensity = save.intensity;
        obj.color = save.color;

        obj.mesh.position.fromArray( save.pos );
        obj.mesh.quaternion.fromArray( save.qua );

        obj.disabled = !!save.disabled;

        angular.merge( obj.opts, save.opts );
        
        if (save.comments) obj.comments.init(save.comments);

        switch( save.stype ) {
            case "HemisphereLight":
                break;
        }

        obj.optsChanged();

        return obj;
    }
}